<template>
  <v-container fluid>
    <!-- Botones de selección de modo -->
    <v-row justify="start" class="mb-4">
      <v-btn-toggle v-model="viewMode" mandatory>
        <v-btn value="table">
          <v-icon left>mdi-view-list</v-icon> Tabla
        </v-btn>
        <v-btn value="cards">
          <v-icon left>mdi-view-grid</v-icon> Tarjetas
        </v-btn>
      </v-btn-toggle>

      <v-divider></v-divider>

      <!-- Boton para añadir articulos del pedio al carrito -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            :disabled="selectedItems.length == 0 || !validQuantity"
            @click="verSeleccionados"
            color="primary"
            class="ml-2"
            v-bind="attrs"
            v-on="on"
          >
            mdi-cart-plus
          </v-icon>
        </template>
        <span>Añadir artículos seleccionados</span>
      </v-tooltip>

      <!-- Boton para modificar el pedido -->
      <v-tooltip v-if="inDate()" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            :disabled="!change"
            @click="updateOrder"
            color="primary"
            class="ml-2"
            v-bind="attrs"
            v-on="on"
          >
            mdi-reload
          </v-icon>
        </template>
        <span>Actualizar pedido</span>
      </v-tooltip>
    </v-row>

    <!-- Modo Tabla -->
    <v-data-table
      v-if="viewMode === 'table'"
      v-model="selectedItems"
      :headers="headers"
      :items="articles"
      class="elevation-1"
      dense
      item-value="id"
      show-select
    >
      <!-- Columna de la imagen -->
      <template v-slot:item.image_1920="{ item }">
        <img v-if="item.image_1920" :src="imageSrc(item)" class="table-image" />
        <v-icon v-else color="grey darken-2">mdi-image-off</v-icon>
      </template>

      <!-- Columna editable de Cantidad -->
      <template v-slot:item.product_uom_qty="{ item }">
        <v-text-field
          v-model.number="item.product_uom_qty"
          type="number"
          min="1"
          dense
          outlined
          hide-details
          class="editable-input"
        ></v-text-field>
        <!-- <span v-else>{{ item.product_uom_qty }}</span> -->
      </template>
    </v-data-table>


    <!-- Modo Tarjetas -->
    <v-row v-if="viewMode === 'cards'" dense>
      <v-col v-for="(item, index) in articles" :key="index" cols="12" sm="6" md="4">
        <v-card outlined class="ma-3 card">
          <v-container fluid>
            <v-row>
              <v-col cols="12" class="text-overline ml-4 text-muted">
                Código: {{ item.default_code }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="8" class="text-h5 text-dark">
                <span class="ml-4">{{ item.product_name }}</span>
              </v-col>
              <v-col cols="12" md="4" class="text-h6 text-primary">
                <span class="ml-4 text-left">
                  {{ item.product_uom_qty }} {{ item.product_uom_qty == 1 ? "Unidad" : "Unidades" }}
                </span>
              </v-col>
            </v-row>
            <v-row class="justify-center ma-2">
              <div class="image-container">
                <img v-if="item.image_1920" :src="imageSrc(item)" alt="Imagen desde Odoo" class="img-small" />
                <v-icon v-else color="grey darken-2" class="icon-small">mdi-image-off</v-icon>
              </div>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <!-- respuesta de realizar pedido -->
    <v-dialog
        v-model="dialog"
        :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-alert :type="alertType">
          <v-row
            align="center"
            no-gutters
          >
            <v-col class="grow">
              {{ error_text }}
            </v-col>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="shrink">
              <v-btn
                outlined
                @click="dialog = false"
              >
                Cerrar
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-dialog>
  </v-container>
</template>


<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
  components: {},

  data() {
    return {
      viewMode: "table", // Modo por defecto
      headers: [
        { text: "Seleccionar", value: "data-table-select", align: "center", sortable: false },
        { text: "Imagen", value: "image_1920", sortable: false },
        { text: "Código", value: "default_code" },
        { text: "Nombre", value: "product_name" },
        { text: "Precio unitario", value: "price_unit" },
        { text: "Descuento", value: "discount" },
        { text: "Importe", value: "price_subtotal" },
        { text: "Cantidad", value: "product_uom_qty" },
      ],

      //array con articulos para enviar al carrito
      selectedItems: [],
      validQuantity: true,

      //para comprobacion de cambios de cantidad en articulos de pedido
      originalArticles: [],
      change: false,
      modifiedArticles: [],

      //fecha actual para poder editar pedidos
      today: null,

      dialog: false,
      error_text: "",
      alertType: "",
    };
  },

  props: {
    order: Object,
  },

  mounted() {
    this.today = moment().tz("Europe/Madrid");

    //guardamos los valores originales para comprobar si hay cambios en cantidades
    this.originalArticles = JSON.parse(JSON.stringify(this.articles));
  },

  computed: {
    ...mapState(["all_articles"]),

    articles() {
      return this.order.articles;
    },
  },
  methods: {
    ...mapActions(["addToCart", "changeNewOrder", "postDataWithReturn"]),

    inDate() {
      const momentDate = moment(this.order.date_order, "YYYY-MM-DD HH:mm:ss");
      const today_formatted = moment(this.today, "YYYY-MM-DD HH:mm:ss");
      
      const diff = today_formatted.diff(momentDate, "days");
      // console.log(diff);

      return diff > 4 ? false : true;
    },

    checkQuantityChanges(newArticles) {
      for (let index = 0; index < newArticles.length; index++) {
        const article = newArticles[index];
        const originalArticle = this.originalArticles[index];

        if (article.product_uom_qty !== originalArticle.product_uom_qty) {
          this.change = true;

          //añadimos el articulo a lineas modificadas
          if (!this.modifiedArticles.includes((article))) this.modifiedArticles.push(article);
        }
      }
    },

    checkCartQuantity(){
      this.selectedItems.forEach((art) => {
        if (art.product_uom_qty >= 1) this.validQuantity = true;
        else this.validQuantity = false; 
      })
    },

    imageSrc(item){
      return `data:image/png;base64,${item.image_1920}`;
    },

    //Funcion para enviar articulos seleccionados de pedidos al carrito
    verSeleccionados() {
      // console.log("Artículos seleccionados:", this.selectedItems);
      this.selectedItems.forEach(article => {
        //buscamos en all_articles el articulo
        let searchArticle = this.all_articles.find((a) => a.default_code == article.default_code && a.default_code);
        // console.log(searchArticle);
        
        if (searchArticle) {
          searchArticle.quantity = article.product_uom_qty;
          this.addToCart(searchArticle);
        } else {
          //buscar en all_articles por el nombre del articulo
          searchArticle = this.all_articles.find((a) => a.name == article.product_name);
          // console.log(searchArticle);

          if (searchArticle) {
            searchArticle.quantity = article.product_uom_qty;
            this.addToCart(searchArticle);
          }
        }
      });
    },
    async updateOrder() {
      console.log("actualizar pedido", this.modifiedArticles);
      try{
        const { success: success } = await this.postDataWithReturn({ path: "django/portal/update_order/", body: this.modifiedArticles });
        console.log(success);
        //desplegar dialog correcto
        this.dialog = true;
        this.error_text = "Pedido modificado correctamente";
        this.alertType = "success";

        this.modifiedArticles = [];
        this.changeNewOrder(true);

        this.change = false;
      } catch(e) {
        console.error("Error al editar pedido", e);

        this.dialog = true;
        this.error_text = "Error al modifcar pedido";
        this.alertType = "error";
      }
    }
  },
  watch: {
    // Observa cambios en la lista de artículos
    articles: {
      deep: true,
      handler(newArticles) {
        this.checkQuantityChanges(newArticles);
        this.checkCartQuantity();
      },
    },
  },
};
</script>

<style scoped>
/* Card styles */
.v-card {
  border-radius: 12px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.v-card:hover {
  transform: translateY(-5px);
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2);
}

/* Text styling */
.text-h5 {
  font-weight: 600;
  color: #333;
}

.text-h6 {
  font-weight: 400;
  color: #007BFF;
}

.text-overline {
  font-size: 14px;
  color: #6c757d;
}

.ml-4 {
  margin-left: 16px;
}

.text-left {
  text-align: left;
}

.text-muted {
  color: #6c757d;
}

.text-dark {
  color: #333;
}

.text-primary {
  color: #007bff;
}

/* Image container styles */
.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.image-container img {
  border-radius: 8px;
  border: 2px solid #e0e0e0;
  max-width: 80px;
  max-height: 80px;
  object-fit: cover;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.image-container img:hover {
  transform: scale(1.05);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.icon-small {
  font-size: 50px;
  background-color: #f0f0f0;
  border-radius: 50%;
  padding: 10px;
}

/* Spacing and layout */
.v-container {
  padding: 20px;
}

.v-card {
  margin-bottom: 20px;
}

.v-row {
  margin-top: 10px;
  margin-bottom: 10px;
}

@media (max-width: 600px) {
  .ml-4 {
    margin-left: 8px;
  }
}
/* Imagen dentro de la tabla */
.table-image {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

/* Imagen dentro de las tarjetas */
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 10px;
}

.img-small {
  max-width: 100px;
  max-height: 100px;
  object-fit: contain;
}

/* Estilos para tarjetas */
.card {
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: scale(1.02);
}

.editable-input {
  max-width: 80px;
  text-align: center;
}
</style>

